



































import OtDocumentList from '@/components/documents/document-list/ot-document-list.vue';
import OtDocumentsFilter from '@/components/documents/document-list/ot-documents-filter.vue';
import { FormModalParams, FormModalSizeEnum } from '@/components/global/modal/form-modal-models';
import OtFormModal from '@/components/global/modal/ot-form-modal.vue';
import OtLoadingSpinner from '@/components/global/ot-loading-spinner.vue';
import OtApi from '@/services/api.service';
import { IVForm } from '@/utils/type-utils';
import { Component, Ref, Vue } from 'vue-property-decorator';
import { DocumentListItem } from '../document-list/document-list-models';
import { DocumentListLevel, DocumentListMode, DocumentsFilter } from '../document-models';
import { SelectDocumentDialogParams, SelectDocumentDialogResult } from './select-document-dialog-models';

@Component({
  components: {
    OtFormModal,
    OtLoadingSpinner,
    OtDocumentList,
    OtDocumentsFilter,
  },
})
export default class OtSelectDocumentDialog extends Vue {
  // * PROPS
  private api = new OtApi();

  // * REFS
  @Ref('formModalRef') private readonly formModalRef!: OtFormModal;
  @Ref('modalContentRef') private readonly modalContentRef!: IVForm;
  @Ref('documentsFilterRef') private readonly documentsFilterRef?: OtDocumentsFilter;

  // * DATA
  private isLoading = false;
  private params: SelectDocumentDialogParams | null = null;
  private filters: DocumentsFilter | null = null;
  private level = DocumentListLevel.Organisation;
  private mode = DocumentListMode.Select;

  private selectedDocuments: DocumentListItem[] = [];

  private get confirmText() {
    return 'Add Selected Document' + (this.selectedDocuments.length > 1 ? 's' : '');
  }
  private get canConfirm() {
    return this.selectedDocuments.length > 0;
  }
  private get orgGid() {
    return this.params?.targetOrganisationGid ?? '';
  }
  private get locationDescription() {
    return this.params?.context ?? '';
  }

  // * METHODS
  private handleFilterUpdate(nextFilter: DocumentsFilter) {
    this.filters = nextFilter;
  }
  private handleSelectionUpdate(nextSelection: DocumentListItem[]) {
    this.selectedDocuments = nextSelection;
  }

  private async initialise(params: SelectDocumentDialogParams) {
    this.isLoading = true;

    // reset ourself from last time
    this.selectedDocuments = [];
    this.filters = null;

    // remember these for other spots we need them
    this.params = params;
    // dunno why. Just feels like we should wait
    await this.$nextTick();

    // Add initialization logic here

    this.documentsFilterRef?.reset();

    this.isLoading = false;
  }

  public async open(params: SelectDocumentDialogParams): Promise<SelectDocumentDialogResult> {
    const baseParams = new FormModalParams({
      title: 'Select Existing Document to add to ' + params.context,
      formRef: this.modalContentRef,
      confirmText: 'Add Selected Document(s)',
      cancelText: 'Cancel',
      size: FormModalSizeEnum.Max,
      contentHandlesOwnScrolling: true,
      bodyContainerCss: {
        position: 'relative',
      },
      onAfterFormMounted: () => {
        this.initialise(params);
      },
      onBeforeConfirmClose: async () => {
        // Add confirmation logic here
        return true;
      },
    });

    const result = await this.formModalRef.open(baseParams);

    // forget the last params. We've got "should we show it" based on there being params
    this.params = null;

    if (result.ok) {
      return new SelectDocumentDialogResult({
        ok: true,
        selectedDocuments: this.selectedDocuments,
      });
    }
    return new SelectDocumentDialogResult({ ok: false });
  }
}
